import { Dispatch, SetStateAction } from 'react';

import { HistoryPlugin } from '@lexical/react/LexicalHistoryPlugin';
import { LinkPlugin } from '@lexical/react/LexicalLinkPlugin';
import { ListPlugin } from '@lexical/react/LexicalListPlugin';
import { OnChangePlugin } from '@lexical/react/LexicalOnChangePlugin';
import { TablePlugin } from '@lexical/react/LexicalTablePlugin';
import { AutoFocusPlugin } from '@lexical/react/LexicalAutoFocusPlugin';
import { EditorState } from 'lexical';

import { TrackMediaIdsAndMentionsPlugin } from './plugins';
import { WysiwygConfigType } from './WysiwygInput';

interface FunctionalPluginsProps {
  config: WysiwygConfigType;
  debouncedOnChange: (editorState: EditorState) => void;
  focusMode?: 'auto' | 'manual';
  setMediaIds: Dispatch<SetStateAction<string[]>>;
  setMentionsData: Dispatch<SetStateAction<{ type: string; id: string }[]>>;
}

export const FunctionalPlugins = ({
  config,
  debouncedOnChange,
  focusMode,
  setMediaIds,
  setMentionsData,
}: FunctionalPluginsProps) => {
  return (
    <>
      {config.plugins.linkAndTablePlugin.table && <TablePlugin />}

      {config.plugins.linkAndTablePlugin.link && (
        <LinkPlugin attributes={{ target: '_blank' }} />
      )}

      {config.plugins.listAndFormatPlugin.list && <ListPlugin />}

      <HistoryPlugin />

      {config.plugins.trackMediaIdsAndMentionsPlugin && (
        <TrackMediaIdsAndMentionsPlugin
          setMediaIds={setMediaIds}
          setMentionsData={setMentionsData}
        />
      )}

      <OnChangePlugin onChange={debouncedOnChange} ignoreSelectionChange />

      {focusMode === 'auto' && <AutoFocusPlugin defaultSelection="rootEnd" />}
    </>
  );
};
